import $ from 'jquery';
import gsap from 'gsap';
 
class NavigationRevealItem {
    constructor(el, index) {
        this.render(el, index);
    }

    animate() {
        var tl = new gsap.timeline();
        

        
        tl.fromTo(this.items, { x:10, opacity: 0 }, { opacity: 1, ease: "power3.out", x: 0, duration: 0.6, stagger: 0.2 });
        
    }

    render(el, index) {
        this.element = $(el);

        this.items = this.element.find('[data-ref="nav-item"], [data-ref="mobile-trigger"]');




        this.animate();
    }
}

class NavigationReaveal {
    static get EVENT() {
        return {

        }
    }

    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {
        new NavigationRevealItem(el, index);
    }
}

export default NavigationReaveal;